import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Mida',
	PageOrientation: 'Orientació',
	Format: 'Format',
	DPI: 'DPI',
	Generate: 'Genera',
	LanguageName: 'Catalan',
	LanguageCode: 'ca'
};

export default translation;
